import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'MyInvestFolio';
const PROD_ORIGIN = 'https://beta.myinvestfolio.io';
const DEFAULT_OG = `${PROD_ORIGIN}/og/default.png`;

/**
 * Per-page SEO + LinkedIn-friendly Open Graph tags.
 *
 * Deliberately omits Twitter Card meta — the founder maintains a limited
 * social-media footprint by design (privacy-first posture). Twitter/X
 * shares will still render a basic preview from the OG tags, but we don't
 * optimise for them.
 *
 * Usage:
 *   <SEO title="Our Philosophy" description="…" path="/our-philosophy" />
 */
const SEO = ({
  title,
  description,
  path = '/',
  ogImage,
  jsonLd,
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Independent Portfolio Infrastructure`;
  const desc = description || 'Independent, encrypted portfolio infrastructure for discerning investors. Continuity System for your private wealth record; Portfolio Clarity for the full analytical view. Multi-asset, multi-currency, multi-jurisdiction.';
  const url = `${PROD_ORIGIN}${path}`;
  const image = ogImage || DEFAULT_OG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph — LinkedIn reads these */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="627" />
      <meta property="og:locale" content="en_GB" />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
